import { Controller } from 'libraries/front-end-core/core/Router'
import getUrl from 'libraries/front-end-core/core/url'
import { SMART_SEARCH } from 'constants/controllers'
import Main from 'redux/containers/pages/smartsearch/SmartSearchContainer'
import Header from 'components/smartsearch/Header'

export default new Controller({
  name: SMART_SEARCH,
  route: 'smartsearch/:flavour',
  controller (
    Router,
    {
      scrollMain,
      pageView,
      pageData = {},
      pageState = {},
      previousPageId,
      params: { flavour },
      query = {}
    },
    render
  ) {
    const queryString = query.q || ''
    const caseFlag = query.boostCases === 'true'
    const pageId = getUrl(
      SMART_SEARCH,
      { flavour },
      { q: queryString, boostCases: caseFlag }
    )

    render(
      { Main, Header },
      { flavour, queryString, caseFlag, query, flavours: pageData.flavours || [] },
      {
        bottleLink: (flavour) => getUrl(SMART_SEARCH, { flavour }, query),
        flavour,
        pageId,
        pageView,
        searchType: 'qa',
        query,
        searchPhrase: queryString
      }
    )
    return pageId
  }
})
